import './assets/main.css'

import { createApp } from 'vue'
import { createPinia } from 'pinia'

import App from './App.vue'
import router from './router'
import './router/permission.js'

// 引用自定义方法
import Prototypes from './utils/prototypes.js'

// 引用高德地图
import '@vuemap/vue-amap/dist/style.css'
import { initAMapApiLoader } from '@vuemap/vue-amap'
// 初始化高德地图
initAMapApiLoader({
  key: '88dc0b237dbf1934d0691bb3df33fd50',
  securityJsCode: 'b1416a021763b7782b9de25c0b9d1523',
  plugins: ['AMap.Icon', 'AMap.Geocoder']
})


// 引用自定义组件库
import Components from './components/index.js'
// 引用自定义组件库
import { setupForm } from './plugins/form/index.js'
import ElementIcons from './plugins/icons/element-plus.js'
import { setupIcons } from './plugins/icons/index.js'

const app = createApp(App)
app.use(createPinia())
app.use(router)
app.use(ElementIcons)
app.use(Components)
app.use(Prototypes)

setupForm(app)
setupIcons(app)

app.mount('#app')